import { render, staticRenderFns } from "./EnrollmentCardOld.vue?vue&type=template&id=0873fefd&scoped=true"
import script from "./EnrollmentCardOld.vue?vue&type=script&lang=js"
export * from "./EnrollmentCardOld.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentCardOld.vue?vue&type=style&index=0&id=0873fefd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873fefd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VMenu,VSpacer})
